export default [
  { id: 1, nome: 'Gleba Nova Olinda Santarém' },
  { id: 2, nome: 'Gleba Nova Olinda - Área I - Juruti' },
  { id: 3, nome: 'Gleba Nova Olinda - Área II - Santarém' },
  { id: 4, nome: 'Gleba Nova Olinda - Área III - Santarém' },
  { id: 5, nome: 'Gleba Nova Olinda II - Juturi' },
  { id: 6, nome: 'Gleba Nova Olinda II - Santarém' },
  { id: 7, nome: 'Gleba Nova Olinda II - Aveiro' },
  { id: 8, nome: 'Gleba Mamuru - Aveiro' },
  { id: 9, nome: 'Gleba Mamuru - Santarém' },
  { id: 10, nome: 'Gleba Guajará I - Prainha' }
]



// WEBPACK FOOTER //
// ./src/constants/glebas.js